import { modules } from 'veritone-redux-common';
const {
  config: { getConfig }
} = modules;

const getUrlApi = state => {
  const config = getConfig(state);
  return config.urlApi;
};

export default getUrlApi
